import { render } from "./ProjectSectionStory.vue?vue&type=template&id=a2223662"
import script from "./ProjectSectionStory.vue?vue&type=script&lang=js"
export * from "./ProjectSectionStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__